import React, { useReducer } from "react";
import PropTypes from "prop-types";
import { testDateTimeSupport, testTouch, testIsMobileSize, testIsIOS } from "./utils";

let cmsData = {};
if (window.sickreport_content) {
  cmsData = {
    ...window.sickreport_content,
    translations: {
      ...window.sickreport_content.translations
    },
    Sick: {
      ...window.sickreport_content.sickform
    },
    Recovery: {
      ...window.sickreport_content.healthyform
    }
  };
}

// Sick eller Recovery
const defaultState = {
  error: 0,
  formType: "Recovery",
  hasVab: true,
  hasPhoneAdvising: true,
  hasAfterRegistration: false,
	hasVabAfterRegistration: false,
	vabCustomerInfo: null,
	hasVabPhoneAdvising: false,
	hasAbsence: false,
  personalNumber: null,
  lime: {},
  customerInfo: null,
  reportReceived: null,
  successType: null,
  siteKey: null,
  action: null,
  token: null,
  browser: {
    datetimeSupport: testDateTimeSupport(),
    touch: testTouch(),
    isMobile: testIsMobileSize(),
    isIOS: testIsIOS()
  }
};

export const RESET_PERSONAL_NUMBER = "SickreportV2/RESET_PERSONAL_NUMBER";
export const SET_PERSONAL_NUMBER = "SickreportV2/SET_PERSONAL_NUMBER";
export const SET_LIME_DATA = "SickreportV2/SET_LIME_DATA";
export const SET_ERROR = "SickreportV2/SET_ERROR";
export const SET_API_VALUES = "SickreportV2/SET_API_VALUES";
export const SET_SUCCESS = "SickreportV2/SET_SUCCESS";
export const SET_RECAPTCH_DATA = "SickreportV2/SET_RECAPTCH_DATA";
export const SET_TOKEN = "SickreportV2/SET_TOKEN";

const reducer = (state, action) => {
  switch (action.type) {
    case RESET_PERSONAL_NUMBER:
      return { ...state, personalNumber: null };
    case SET_PERSONAL_NUMBER:
      return { ...state, personalNumber: action.personalNumber };
    case SET_LIME_DATA:
      return { ...state, lime: action.lime };
    case SET_ERROR:
      return {
        ...state,
        error: action.error
      };
    case SET_API_VALUES:
      return {
        ...state,
        lime: action.lime,
        formType: action.formType,
        hasPhoneAdvising: action.hasPhoneAdvising,
        hasVab: action.hasVab,
        customerInfo: action.customerInfo,
        hasAfterRegistration: action.hasAfterRegistration,
        reportReceived: action.reportReceived,
				hasVabAfterRegistration: action.hasVabAfterRegistration,
				vabCustomerInfo: action.vabCustomerInfo,
				hasVabPhoneAdvising: action.hasVabPhoneAdvising,
				hasAbsence: action.hasAbsence
      };
    case SET_SUCCESS:
      return {
        ...state,
        successType: action.successType
      };
    case SET_RECAPTCH_DATA:
      return {
        ...state,
        siteKey: action.siteKey,
        action: action.action
      };
    case SET_TOKEN:
      return {
        ...state,
        token: action.token
      };

    default:
      return state;
  }
};

export const CMSContext = React.createContext();
export const StateContext = React.createContext();
export const StateDispatchContext = React.createContext();

export function StateProvider({ children, initialState }) {
  const [state, dispatch] = useReducer(reducer, {
    ...defaultState,
    ...initialState
  });

  return (
    <StateContext.Provider value={state}>
      <StateDispatchContext.Provider value={dispatch}>
        <CMSContext.Provider value={cmsData}>{children}</CMSContext.Provider>
      </StateDispatchContext.Provider>
    </StateContext.Provider>
  );
}

StateProvider.defaultProps = {
  initialState: {}
};

StateProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialState: PropTypes.shape({})
};
